import type { CommitmentUsageReport } from '@vy/types';
import { caseInsensitiveIncludes, isNullOrUndefined } from '@vy/utils';
import { useMemo } from 'react';
import { VyTableLite } from '../../../../../components/new-design/table/vy-table/VyTable';
import { COMMITMENT_USAGE_REPORT_COLUMNS } from './CommitmentUsageReportTableColumns';
import { GridApiPro } from '@mui/x-data-grid-pro';

type CommitmentUsageReportTableProps = {
  rows: CommitmentUsageReport;
  filter?: string;
  isLoading?: boolean;
  apiRef?: React.MutableRefObject<GridApiPro>;
};

export const CommitmentUsageReportTable: React.FC<CommitmentUsageReportTableProps> = ({
  rows,
  isLoading,
  filter,
  apiRef,
}) => {
  const filteredRows = useMemo(
    () =>
      rows.filter(
        ({ customerName }) => isNullOrUndefined(filter) || caseInsensitiveIncludes(customerName, filter),
      ),
    [rows, filter],
  );

  return (
    <VyTableLite
      apiRef={apiRef}
      items={filteredRows}
      columns={COMMITMENT_USAGE_REPORT_COLUMNS}
      loadingItems={isLoading}
      getRowId={() => crypto.randomUUID()}
    />
  );
};
